<template>
  <div>
    <div :key="tag.id + '_' + i" v-for="(tag, i) in tags" class="relation">
      <div class="tag parent">
        {{tag.parentName}}
      </div>
      <div class="relation-icon">⟶</div>
      <div class="tag child">
        {{tag.name}}
      </div>
      <div class="actions">
        <a @click="() => onOpenRelation(tag)" :class="['edit', projectCategoriesIsLoading ?  'text-secondary disabled' : 'text-info']" :disabled="projectCategoriesIsLoading" v-tooltip="$t('form.button.edit')">
          <i class="icon far fa-edit"></i>
        </a>
        <a @click="() => onRemoveRelation(tag)" :class="['remove', projectCategoriesIsLoading ?  'text-secondary disabled' : 'text-danger']" v-tooltip="$t('form.button.remove')">
          <i class="fas fa-trash"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    relationType: String,
    relation: Object,
    onEdit: Function,
    onOpen: Function,
    onRemove: Function
  },

  data: function() {
    const relationTags = this.relation?.tags || this.relation?.child_tags;
    const tags = relationTags?.map(t => ({ ...t, name: t.name, parentName: (this.relationType == 'hierarchy' ? this.relation.parent_tag_name : this.relation?.tag_name) }));
    return {
      tags
    }
  },
  computed: {
    ...mapState({
      projectCategoriesIsLoading: state => state.projectSetup.projectCategorySetup?.isBusy,
    }),
  },

  methods: {
    onEditRelation: function() {
      this.onEdit(this.relation);
    },

    onOpenRelation: function(tag) {
      this.onOpen(this.relationType, this.relation, tag);
    },

    onRemoveRelation: function (child) {
      let data;

      if (child && child?.association_id) {
        data = {
          id: this.relation.id,
          name: this.relation.tag_name,
          childName: child?.name,
          delete_associations: [child?.association_id]
        }
      } else {
        data = { ...this.relation, tag_id: child?.id };
        data.childName = child.parentName;
      }

      this.onRemove(data);
    }
  }
}
</script>

<style lang="scss" scoped>
  .relation {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .tag {
      color: #666;
      background-color: #f1f1f1;
      padding: 1px 8px;
      border-radius: 3px;
      white-space: nowrap;
      max-width: 150px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: default;
    }


    .relation-icon {
      margin: 0 20px;
    }

    .actions {
      margin-left: 10px;
      width: 55px;
      min-width: 55px;

      .edit,
      .remove {
        cursor: pointer;
        margin: 0 5px;
      }
    }
  }
</style>